// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Звіти комітету» (Committee reports, ключ `creport`, група `committees`). */
export const committeeReportsManifest: IModuleManifest = {
  key: 'creport',
  group: 'committees',
  slug: 'committee-reports',
  prefix: 'CRP',
  name: { en: 'Committee reports', uk: 'Звіти комітету' },
  entities: [
    { key: 'creport', slug: 'creport', name: { en: 'Committee reports', uk: 'Звіти комітету' }, main: true },
    { key: 'report_section', slug: 'report-section', name: { en: 'Report Sections', uk: 'Розділи' }, main: false },
    { key: 'report_reviewer', slug: 'report-reviewer', name: { en: 'Report Reviewers', uk: 'Рецензенти' }, main: false },
    { key: 'report_conclusion', slug: 'report-conclusion', name: { en: 'Report Conclusions', uk: 'Висновки' }, main: false },
    { key: 'report_version', slug: 'report-version', name: { en: 'Report Versions', uk: 'Версії' }, main: false },
    { key: 'report_status', slug: 'report-status', name: { en: 'Report Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/committeeReportsSlice').then((m) => m.committeeReportsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
